import HttpClient from "@/common/boot/HttpClient"

const listarProvedores = async ({ commit, state }, payload) => {

  commit('CARREGANDO', true);
    const params = state.relacoesListagem.length
      ? { with: state.relacoesListagem, ...payload }
      : payload;
    await HttpClient.get('/ctrl-provedores', { params }).then(response => {
        commit('LISTAR_DADOS', response.data.data);
        return response;
    });
  commit('CARREGANDO', false);
}

const listarProvedoresDeletados = async ({ commit }) => {
  commit('CARREGANDO', true);
  await HttpClient.get('/ctrl-provedores', { params: { trashed: true } }).then(response => {
      const itens = response.data.data || [];
      commit('LISTAR_DELETADOS', itens.filter(item => item.deleted_at));
      return response;
  });
  commit('CARREGANDO', false);
}

const recarregarListasProvedores = async (dispatch) => {
  await dispatch('listarProvedores');
  await dispatch('listarProvedoresDeletados');
}

const excluirProvedores = async ({ commit, dispatch },  payload) => { 
  commit('CARREGANDO', true);
    let qtdRows = payload.length;
    for(let i=0;i<qtdRows;++i){
      await excluir(payload[i]);
    }
   
    await recarregarListasProvedores(dispatch);

    commit('CARREGANDO', false);
}  

const excluir = async(linha) => {
  const resp = await HttpClient.delete(`/ctrl-provedores/${linha.id}`).then(response => { return response; });
  return resp;
}

const salvarProvedor = async ({ commit,dispatch }, payload) => {

  commit('CARREGANDO', true);

  return await HttpClient.post('/ctrl-provedores', payload).then(response => {
    dispatch('listarProvedores');
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  });
}

const recuperarProvedor = ({ commit, state }, payload) => {

  commit('CARREGANDO', true);

  const item = state.items.filter(item => item.id === payload.id);

  if(item.length) {
    commit('INSERIR_PROCESSO_SELECIONADO', ...item);
    return true;
  }

  commit('CARREGANDO', false);

  return false;
}

const atualizarProvedor = async ({ commit,dispatch }, payload) => {
  commit('CARREGANDO', true);

  return await HttpClient.put(`/ctrl-provedores/${payload.id}`, payload).then(response => {
    dispatch('listarProvedores');
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  })
}

const restaurarProvedor = async ({ commit, dispatch }, payload) => {
    commit('CARREGANDO', true);

    return await HttpClient.post(`/ctrl-provedores/${payload}/restaurar/`).then(response => {
        return recarregarListasProvedores(dispatch).then(() => response);
    }).finally(() => {
        commit('CARREGANDO', false);
    });
}

const buscarProvedorComDesignacoes = async ({ commit }, id) => {
  commit('CARREGANDO', true);
  try {
    const response = await HttpClient.get(`/ctrl-provedores/${id}/designacoes`);
    return response.data?.data ?? response.data;
  } finally {
    commit('CARREGANDO', false);
  }
}

const sincronizarDesignacoes = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  try {
    const response = await HttpClient.post(
      `/ctrl-provedores/${payload.id}/sincronizar-designacoes`,
      { designacoes: payload.designacoes }
    );
    return response;
  } finally {
    commit('CARREGANDO', false);
  }
}

const salvarSlaProvedor = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  try {
    const response = await HttpClient.put(
      `/sla-provedores/provedor/${payload.ctrl_provedor_id}`,
      { sla: payload.sla }
    );
    return response.data?.data ?? response.data;
  } finally {
    commit('CARREGANDO', false);
  }
}

const definirRelacoesListagem = ({ commit }, relacoes) => {
  commit('DEFINIR_RELACOES_LISTAGEM', relacoes);
}

const removerSlaProvedor = async ({ commit }, id) => {
  commit('CARREGANDO', true);
  try {
    return await HttpClient.delete(`/sla-provedores/${id}`);
  } finally {
    commit('CARREGANDO', false);
  }
}

export {
  listarProvedores,
  listarProvedoresDeletados,
  excluirProvedores,
  salvarProvedor,
  recuperarProvedor,
  atualizarProvedor,
  restaurarProvedor,
  buscarProvedorComDesignacoes,
  sincronizarDesignacoes,
  salvarSlaProvedor,
  removerSlaProvedor,
  definirRelacoesListagem
}